import { PromoToggleKey } from '~/services/PromoService';

const ALLOW_PARENT_PROMO_CODE_USAGE_TOGGLE: PromoToggleKeyWithFallback = 'allow-parent-promo-code-usage';
const DISALLOW_PROMO_REQUESTS_TOGGLE: PromoToggleKeyWithFallback = 'disallow-promo-requests';

export type PromoToggleKeyWithFallback = PromoToggleKey | (string & {});

export function hasAllowParentPromoCodeRequestsToggle(
  toggles: Array<PromoToggleKeyWithFallback> | null | undefined,
): boolean {
  return !!toggles?.includes(ALLOW_PARENT_PROMO_CODE_USAGE_TOGGLE);
}

export function hasDisallowPromoRequestsToggle(toggles: Array<PromoToggleKeyWithFallback> | null | undefined): boolean {
  return !!toggles?.includes(DISALLOW_PROMO_REQUESTS_TOGGLE);
}
